module.exports = __webpack_public_path__ + "media/orbital_decay.c3cc44c2.webm";